import { Chart, Filler, LineController, LineElement, PointElement } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { ChartTitle } from 'components/atoms/ChartTitle'
import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { colors } from 'theme'
import { chartOptions } from 'utils/chartOptions'

const data = {
  type: 'line',
  plugins: [ChartDataLabels],
  data: {
    labels: [],
    datasets: [
      {
        backgroundColor: colors.lightGreen,
        data: [],
        pointRadius: 13,
        pointBorderColor: 'white',
        pointBorderWidth: 8,
        hoverRadius: 13,
        hoverBorderWidth: 8,
        fill: 'origin',
      },
    ],
  },
  options: {
    ...chartOptions,
    plugins: {
      ...chartOptions.plugins,
      tooltip: {
        enabled: false,
      },
      datalabels: {
        anchor: 'end',
        align: 'end',
        font: {
          family: 'Montserrat',
          weight: 'bold',
          color: colors.deepBlue,
        },
      },
    },
  },
}

const TotalScore = ({ selectedMember, scores, formatedMonthYears }) => {
  const canvas = useRef(null)
  useEffect(() => {
    Chart.register(LineController, PointElement, LineElement, Filler)

    const chart = new Chart(canvas.current.getContext('2d'), {
      ...data,
      data: {
        ...data.data,
        labels: formatedMonthYears,
        datasets: [{
          ...data.data.datasets[0],
          data: scores.map(score => score.sumCalculatedScore),
        }],
      },
    })

    return () => chart.destroy()
  }, [scores, formatedMonthYears])

  const memberName = selectedMember === 'team'
    ? "l'équipe"
    : `${selectedMember?.firstname} ${selectedMember?.lastname}`

  return (
    <Wrapper>
      <ChartTitle title={`Score cumulé de ${memberName}`} />
      <ChartContainer>
        <canvas id="totalScore"
          ref={ canvas }
        >
        </canvas>
      </ChartContainer>
    </Wrapper>
  )
}

TotalScore.propTypes = {
  selectedMember: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      firstname: PropTypes.string.isRequired,
      lastname: PropTypes.string.isRequired,
    }),
  ]).isRequired,
  formatedMonthYears: PropTypes.arrayOf(PropTypes.string).isRequired,
  scores: PropTypes.arrayOf(PropTypes.shape({
    sumCalculatedScore: PropTypes.number.isRequired,
  })).isRequired,
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const ChartContainer = styled.div`
  position: relative;
  height: 400px;
`

export default TotalScore
